import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { ShipmentService } from '@core/services/shipment/shipment.service';
import { RecoverableShipmentsStore } from '@core/services/shipment/recoverable-shipments.store';
import { Button } from 'primeng/button';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Banner "¡Tu pago fue recibido!" para envíos pagados pero incompletos
 * (payment_status PAID + requires_action true en /flow-status).
 * Sigue el mismo patrón condicional que GuestBannerComponent.
 *
 * Solo lee RecoverableShipmentsStore — quien dispara refresh() es
 * ClientHeaderComponent, que siempre está montado junto a este banner.
 */
@Component({
  selector: 'd2d-payment-recovery-banner',
  imports: [Button, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './payment-recovery-banner.component.html',
})
export class PaymentRecoveryBannerComponent {
  private readonly navigationService = inject(NavigationService);
  private readonly shipmentService = inject(ShipmentService);
  readonly store = inject(RecoverableShipmentsStore);

  readonly dismissed = signal(false);

  dismiss(): void {
    this.dismissed.set(true);
  }

  resume(): void {
    const items = this.store.items();
    if (items.length === 1) {
      const internalCode = items[0].id;
      this.shipmentService.getFlowStatus(internalCode).subscribe({
        next: (status) =>
          this.navigationService.navigate(status.redirect_to, {
            queryParams: { ic: internalCode },
          }),
        error: () => this.navigationService.navigate('user/shipments'),
      });
      return;
    }
    this.navigationService.navigate('user/shipments');
  }
}
